<template>
  <button
    type="button"
    class="btn btn-outline-light m-0 p-0 btn-block !flex items-center justify-center"
  >
    <slot></slot>
  </button>
</template>
